import { doProcessRules } from '../../../lib/processPortalRules'

export const processCondRulesBatch = (state, action) => {
  const paramsList = action.payload
  let resultState = state

  paramsList.forEach((params) => {
    const [path, , fullPath, rowIndex] = params

    resultState = doProcessRules(state, false, path, fullPath, null, false, null, rowIndex)
  })

  return resultState
}
